<template>
  <div
    v-if="
      excludedThemes.includes(theme) &&
      company.company_key !== 'jacksonsproperty' &&
      company.company_key !== 'neilking' &&
      company.company_key !== 'propertyconnections'
    "
    :style="backgroundColor"
  >
    <library-container :style="backgroundColor" style="width: 100%">
      <div id="wrapper" class="tw-py-20">
        <div class="g-0 tw-flex tw-grid tw-w-full tw-grid-cols-12 tw-justify-center tw-px-4 xl:tw-p-5">
          <div class="tw-col-span-12">
            <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
              <lazy-library-title
                tag="h2"
                v-if="variables.boxTitleText"
                :text="variables.boxTitleText"
                class="search-box-title tw-mb-10"
              ></lazy-library-title>
              <div class="tw-flex tw-w-full tw-justify-center">
                <div class="tw-mt-3 tw-grid tw-w-full tw-grid-cols-9 tw-gap-y-3 xl:tw-gap-y-0">
                  <div class="tw-col-span-12 xl:tw-col-span-2">
                    <div class="tw-grid tw-grid-cols-12 tw-border-r tw-border-[var(--default-border-color)]">
                      <div
                        class="tw-col-span-6 tw-rounded-sm xl:tw-col-span-6 2xl:tw-col-span-6"
                        style="background-color: var(--white)"
                      >
                        <div
                          class="py-3 px-4 text-center text-weight-light n-cursor-pointer m-1 tw-rounded-sm tw-uppercase"
                          :class="searchType === PFilterSearchType.SALES ? 'm-1' : ''"
                          :style="searchType === PFilterSearchType.SALES ? selectedBoxColorStyle : ''"
                          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
                        >
                          <lazy-library-text :text="variables.buyOptionText"></lazy-library-text>
                        </div>
                      </div>
                      <div
                        class="tw-col-span-6 tw-rounded-sm xl:tw-col-span-6 2xl:tw-col-span-6"
                        style="background-color: var(--white)"
                      >
                        <div
                          class="py-3 px-4 text-center text-weight-light n-cursor-pointer m-1 tw-rounded-sm tw-uppercase"
                          :class="searchType === PFilterSearchType.LETTINGS ? 'm-1' : ''"
                          :style="searchType === PFilterSearchType.LETTINGS ? selectedBoxColorStyle : ''"
                          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
                        >
                          <lazy-library-text :text="variables.rentOptionText"></lazy-library-text>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tw-col-span-12 tw-flex tw-h-[60px] tw-content-start tw-items-center xl:tw-col-span-6 xl:tw-h-full"
                    style="background-color: var(--white); border-right: 1px solid var(--default-border-color)"
                  >
                    <locations
                      v-model="searchInput"
                      v-model:locations="locations"
                      :is-mile-selection-visible="false"
                      :is-search-icon-hidden="true"
                      class="tw-h-full"
                    />
                  </div>
                  <div class="tw-col-span-12 xl:tw-col-span-1" :style="buttonColorsStyle">
                    <nc-button :label="variables.searchButtonText" :height="64" @on-click="onSearched()">
                      <template #label>
                        <div class="nc-secondary-button tw-flex tw-flex-row tw-items-center tw-gap-x-2">
                          <span class="nc-secondary-button__text tw-uppercase">Search</span>
                          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path
                              class="nc-secondary-button__icon"
                              d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </template>
                    </nc-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </library-container>
  </div>

  <div v-if="company.company_key === 'neilking'" :style="backgroundColor">
    <library-container :style="backgroundColor" style="width: 100%">
      <div id="wrapper" class="tw-py-20">
        <div class="g-0 tw-flex tw-grid tw-w-full tw-grid-cols-12 tw-justify-center tw-px-4 xl:tw-p-5">
          <div class="tw-col-span-12">
            <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
              <lazy-library-title
                tag="h2"
                v-if="variables.boxTitleText"
                :text="variables.boxTitleText"
                class="search-box-title tw-mb-10"
              ></lazy-library-title>
              <div class="tw-flex tw-w-full tw-justify-center">
                <div class="tw-mt-3 tw-grid tw-w-full tw-grid-cols-9 tw-gap-y-3 xl:tw-gap-y-0">
                  <div class="tw-col-span-12 xl:tw-col-span-2">
                    <div class="tw-grid tw-grid-cols-12 tw-border-r tw-border-[var(--default-border-color)]">
                      <div
                        class="tw-col-span-6 tw-rounded-sm xl:tw-col-span-6 2xl:tw-col-span-6"
                        style="background-color: var(--white)"
                      >
                        <div
                          class="py-3 px-4 text-center text-weight-light n-cursor-pointer m-1 tw-rounded-sm tw-uppercase"
                          :class="searchType === PFilterSearchType.SALES ? 'm-1' : ''"
                          :style="searchType === PFilterSearchType.SALES ? selectedBoxColorStyle : ''"
                          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
                        >
                          <lazy-library-text :text="variables.buyOptionText"></lazy-library-text>
                        </div>
                      </div>
                      <div
                        class="tw-col-span-6 tw-rounded-sm xl:tw-col-span-6 2xl:tw-col-span-6"
                        style="background-color: var(--white)"
                      >
                        <div
                          class="py-3 px-4 text-center text-weight-light n-cursor-pointer m-1 tw-rounded-sm tw-uppercase"
                          :class="searchType === PFilterSearchType.LETTINGS ? 'm-1' : ''"
                          :style="searchType === PFilterSearchType.LETTINGS ? selectedBoxColorStyle : ''"
                          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
                        >
                          <lazy-library-text :text="variables.rentOptionText"></lazy-library-text>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tw-col-span-12 tw-flex tw-h-[60px] tw-content-start tw-items-center xl:tw-col-span-6 xl:tw-h-full"
                    style="background-color: var(--white); border-right: 1px solid var(--default-border-color)"
                  >
                    <locations
                      v-model="searchInput"
                      v-model:locations="locations"
                      :is-mile-selection-visible="false"
                      :is-search-icon-hidden="true"
                      class="tw-h-full"
                    />
                  </div>
                  <div class="tw-col-span-12 xl:tw-col-span-1" :style="buttonColorsStyle">
                    <nc-button :label="variables.searchButtonText" :height="64" @on-click="onSearched()">
                      <template #label>
                        <div class="nc-secondary-button tw-flex tw-flex-row tw-items-center tw-gap-x-2">
                          <span class="nc-secondary-button__text tw-uppercase">Search</span>
                          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path
                              class="nc-secondary-button__icon"
                              d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </template>
                    </nc-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </library-container>
  </div>
  <!-- THEME 4... -->
  <section
    v-else-if="!excludedThemes.includes(theme) && variant === variants.v1"
    class="n-section-secondary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="on-the-fly-search-box tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-8">
      <div v-if="vars.titleHtml" v-html="vars.titleHtml" style="color: var(--c-text-secondary)"></div>
      <h3 v-else>{{ vars.titleText }}</h3>

      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="tw-relative tw-flex tw-w-full max-lg:tw-flex-col max-lg:tw-gap-7"
        :style="`border-radius: var(--rounded);`"
      >
        <div
          v-if="vars.horizontalBool"
          class="searchbox-option tw-flex tw-border-r tw-bg-white max-lg:tw-w-full max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] max-md:tw-border lg:tw-p-[2px]"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button lg:!tw-rounded-none"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button lg:!tw-rounded-none"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>
        <locations
          v-model="searchInput"
          v-model:locations="locations"
          :is-mile-selection-visible="false"
          :is-search-icon-hidden="true"
          version="v2"
          :horizontal-layout="vars.horizontalBool"
        />
        <button
          @click="onSearched()"
          class="search-box-btn n-primary tw-h-full lg:tw-absolute lg:tw-right-0 lg:tw-top-0"
          :class="{
            'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
          }"
        >
          <svg
            v-if="vars.isSearchIconBool"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
            />
          </svg>
          {{ vars.searchButtonText }}
        </button>
      </div>
    </div>
  </section>

  <!-- With description -->
  <section
    v-else-if="!excludedThemes.includes(theme) && variant === variants.v4"
    class="n-section-secondary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="on-the-fly-search-box tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6">
      <div
        v-if="vars.titleHtml"
        v-html="vars.titleHtml"
        style="color: var(--c-text-primary)"
        class="tw-text-center"
      ></div>
      <h3 v-else>{{ vars.titleText }}</h3>
      <p class="tw-max-w-[700px] tw-text-center">{{ vars.descriptionText }}</p>
      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="tw-relative tw-flex tw-w-full tw-max-w-[1200px] max-lg:tw-flex-col max-lg:tw-gap-7"
        :style="`border-radius: var(--rounded);`"
      >
        <div
          v-if="vars.horizontalBool"
          class="searchbox-option tw-flex tw-border-r tw-bg-white max-lg:tw-w-full max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] max-md:tw-border lg:tw-p-[2px]"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button lg:!tw-rounded-none"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button lg:!tw-rounded-none"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>
        <locations
          v-model="searchInput"
          v-model:locations="locations"
          :is-mile-selection-visible="false"
          :is-search-icon-hidden="true"
          version="v2"
          :horizontal-layout="vars.horizontalBool"
        />
        <button
          @click="onSearched()"
          class="search-box-btn n-primary tw-h-full lg:tw-absolute lg:tw-right-0 lg:tw-top-0"
          :class="{
            'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
          }"
        >
          <svg
            v-if="vars.isSearchIconBool"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
            />
          </svg>
          {{ vars.searchButtonText }}
        </button>
      </div>
    </div>
  </section>
  <!-- version 6  -->
  <section
    v-else-if="!excludedThemes.includes(theme) && variant === variants.v2"
    class="n-section-secondary on-the-fly-search-box-section"
    :class="{ 'new-homes': $route.path === '/new-homes' }"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <BlockSymbol
      v-if="vars.blockPositionText"
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-symbol="String(vars?.blockSymbolText || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
      :image-class="`tw-max-w-full lg:tw-max-w-[45%] ${company.company_key === 'pendlehillproperties' ? 'tw-hidden !tw-right-0 md:tw-block' : ''}`"
      :block-logo-image="String(vars?.blockLogoImage)"
      :company-key="company.company_key"
    />

    <div
      v-if="company.company_key === 'townandcityhomes'"
      class="tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-hidden lg:tw-block"
    >
      <span
        ><svg width="419" height="445" viewBox="0 0 419 445" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_9_2220)">
            <path
              d="M403.2 237.4C378.6 199.8 332.1 189.3 298.1 195.6C255.7 203.5 224.3 239.5 211.1 279.9C204.7 300.1 202.9 321.4 206.5 340.8C211.1 365.1 223.6 383 233.2 394.1C234.5 395.3 234.8 396.9 234.2 397.7C233.7 398.4 232.7 398.4 232 398.3C230.3 398 229.3 396.8 228.1 395.8C226.9 394.8 225.9 393.6 224.7 392.4C222.5 390.2 220.4 387.9 218.3 385.4C214.1 380.6 210.4 375.5 206.9 370.3C203.5 365.1 200.5 359.5 197.9 353.8C195.2 348.1 193 342.3 191.2 336.3C189.4 330.3 187.9 324.2 187 318C186 311.9 185.4 305.6 185.2 299.3C185.1 293 185.4 286.7 185.9 280.4V279.9C186.7 273.8 187.8 267.6 189.3 261.6C190.1 258.6 191 255.8 191.8 252.9C194.3 245.3 198.5 238.2 201.1 230.7L137.5 167.7C71.3 195.4 66.2 197.5 0 225V429.1C0 431 0.4 432.8 1.2 434.6C3.3 440.1 8.7 444 15 444H333.8C333.6 444 333.5 443.8 333.3 443.7C326.4 439.7 309.8 428.3 301.1 407C290.2 380 295.7 345.9 318.8 324.3C323.1 320.1 328.1 316.7 333.3 314C357.9 300.5 389.8 301.7 414.9 319.1C416.8 311.9 426.4 272.7 403.2 237.2"
              fill="#2D1559"
            />
            <path
              d="M190.9 180.5C190.9 182.2 190.9 183.8 190.7 185.5H227.7C227.5 183.8 227.5 182.2 227.5 180.5C227.5 140.7 255.5 108.6 290.1 108.6C324.7 108.6 295.6 108.8 298.3 109.3V0C270.2 0 247.2 22.9 247.2 51.2H171C171 22.9 148.1 0 119.9 0V109.3C122.6 108.8 125.3 108.6 128.1 108.6C162.7 108.6 190.7 140.7 190.7 180.5"
              fill="#2D1559"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_2220">
              <rect width="418.5" height="444.2" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>

    <div class="on-the-fly-search-box tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6">
      <div class="text-container">
        <p v-if="vars.subTitleText && company.company_key !== 'pendlehillproperties'" class="lg:tw-text-center">
          {{ vars.subTitleText }}
        </p>
        <h3 v-if="vars.titleText && company.company_key !== 'pendlehillproperties'">
          {{ vars.titleText }}
        </h3>

        <h6
          v-if="vars.subTitleText && company.company_key === 'pendlehillproperties'"
          class="tw-text-white lg:tw-text-center"
        >
          {{ vars.subTitleText }}
        </h6>
        <h2 v-if="vars.titleText && company.company_key === 'pendlehillproperties'" class="tw-text-white">
          {{ vars.titleText }}
        </h2>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" />
      </div>
      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="search-button-container tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="property-searchbox-container on-the-fly tw-relative tw-flex tw-w-full tw-gap-4 max-lg:tw-flex-col max-lg:tw-gap-7"
        :style="`border-radius: var(--rounded);`"
      >
        <img
          v-if="vars.mascottEnabledBool"
          :src="vars.mascottImage"
          alt="mascott"
          class="tw-pointer-events-none tw-absolute -tw-right-2 -tw-top-[52px] tw-w-24 md:-tw-top-[81px] md:tw-w-[160px]"
          style="z-index: 1000"
        />
        <div
          v-if="vars.horizontalBool && vars.buyOptionText && vars.rentOptionText"
          :class="[
            'searchbox-option tw-flex tw-w-full max-lg:tw-w-full max-lg:tw-p-[1px] max-md:tw-border lg:tw-max-w-[224px] lg:tw-p-[2px]',
            company.company_key !== 'pendlehillproperties' ? 'tw-border' : '',
          ]"
          style="border-radius: var(--rounded); border-color: var(--c-border)"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button select-button-sales"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button select-button-rent"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>
        <div class="input-row">
          <locations
            v-model="searchInput"
            v-model:locations="locations"
            :is-mile-selection-visible="false"
            :is-search-icon-hidden="true"
            version="v2"
            :horizontal-layout="vars.horizontalBool"
            :placeholder="variables.searchBoxPlaceholderText"
          />
          <button
            @click="onSearched()"
            :aria-label="String(vars.searchButtonText) || 'Search'"
            class="search-box-btn n-primary tw-h-full lg:tw-absolute lg:tw-right-0 lg:tw-top-0"
            :class="{
              'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
            }"
          >
            <svg
              v-if="vars.isSearchIconBool"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              class="tw-flex-shrink-0"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
              />
            </svg>
            {{ vars.searchButtonText }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-else-if="!excludedThemes.includes(theme) && variant === variants.v3 && theme !== 'theme9'"
    class="layout-pt-lg layout-pb-lg on-the-fly-search-box-section"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="on-the-fly-search-box tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6">
      <div>
        <p v-if="vars.subTitleText" class="lg:tw-text-center">{{ vars.subTitleText }}</p>
        <h2 v-if="vars.titleText">{{ vars.titleText }}</h2>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" />
      </div>
      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="search-button-container tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="property-searchbox-container on-the-fly tw-relative tw-flex tw-w-full tw-flex-col tw-gap-4 max-lg:tw-gap-7 lg:tw-flex-row"
        :style="`border-radius: var(--rounded);`"
      >
        <div
          v-if="vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
          class="search-button-container tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button max-lg:tw-border-none"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>

        <!-- input-row masaüstünde row, mobilde column olacak -->
        <div class="input-row tw-flex-col tw-flex-nowrap lg:tw-w-full lg:!tw-flex-row">
          <locations
            v-model="searchInput"
            v-model:locations="locations"
            :is-mile-selection-visible="false"
            :is-search-icon-hidden="true"
            version="v2"
            :horizontal-layout="vars.horizontalBool"
            placeholder="Search by location"
          />
          <button
            @click="onSearched()"
            class="search-box-btn n-primary tw-mt-2 tw-h-full tw-w-full tw-uppercase lg:tw-absolute lg:tw-right-0 lg:tw-top-0 lg:tw-mt-0 lg:tw-w-[30%]"
            :class="{
              'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
            }"
          >
            <svg
              v-if="vars.isSearchIconBool"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
              />
            </svg>
            {{ vars.searchButtonText }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-else-if="theme === 'theme9' && variant === variants.v3"
    class="section-padding on-the-fly-search-box-section"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="on-the-fly-search-box tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6">
      <div>
        <p v-if="vars.subTitleText" class="lg:tw-text-center">{{ vars.subTitleText }}</p>
        <h2 v-if="vars.titleText">{{ vars.titleText }}</h2>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" />
      </div>
      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="search-button-container tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="property-searchbox-container on-the-fly tw-relative tw-flex tw-w-full tw-flex-col tw-gap-4 max-lg:tw-gap-7 lg:tw-flex-row"
        :style="`border-radius: var(--rounded);`"
      >
        <div
          v-if="vars.horizontalBool && vars.buyOptionText && vars.rentOptionText"
          class="searchbox-option tw-flex tw-w-full !tw-p-[1px] lg:tw-h-[78px] lg:tw-w-[30%]"
          style="border: 1px solid var(--c-text_primary) !important"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button select-button-sales tw-uppercase"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button select-button-rent tw-uppercase"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>

        <!-- input-row masaüstünde row, mobilde column olacak -->
        <div class="input-row tw-flex-col tw-flex-nowrap lg:tw-w-full lg:!tw-flex-row">
          <locations
            v-model="searchInput"
            v-model:locations="locations"
            :is-mile-selection-visible="false"
            :is-search-icon-hidden="true"
            version="v2"
            :horizontal-layout="vars.horizontalBool"
            :placeholder="variables.searchBoxPlaceholderText"
          />
          <button
            @click="onSearched()"
            class="search-box-btn n-primary tw-mt-2 tw-h-full tw-w-full tw-uppercase lg:tw-absolute lg:tw-right-0 lg:tw-top-0 lg:tw-mt-0 lg:tw-w-[30%]"
            :class="{
              'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
            }"
          >
            <svg
              v-if="vars.isSearchIconBool"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
              />
            </svg>
            {{ vars.searchButtonText }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    v-else-if="company.company_key === 'jacksonsproperty'"
    class="on-the-fly-search-box-section tw-py-16 lg:tw-py-24"
    :style="`background-color: var(${vars.backgroundColor})`"
  >
    <div
      class="on-the-fly-search-box container tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-3"
    >
      <div>
        <p v-if="vars.subTitleText" class="lg:tw-text-center">{{ vars.subTitleText }}</p>
        <h3 class="tw-mb-6 tw-text-center !tw-text-white" v-if="vars.boxTitleText">{{ vars.boxTitleText }}</h3>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" />
      </div>
      <div
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-0"
        style="border-radius: var(--rounded)"
      >
        <div
          v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
          class="search-button-container tw-gap- tw-flex tw-rounded-[var(--rounded)] tw-bg-white tw-p-[3px] max-lg:tw-w-full lg:tw-gap-4 lg:tw-rounded-l-[var(--rounded)] lg:tw-rounded-r-none"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button tw-uppercase"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>
          <button
            v-if="vars.rentOptionText"
            class="select-button tw-uppercase max-lg:tw-border-none"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>
        <div
          class="property-searchbox-container on-the-fly tw-relative tw-flex tw-w-full tw-flex-col tw-gap-4 max-lg:tw-gap-7 lg:tw-flex-row"
          :style="`border-radius: var(--rounded);`"
        >
          <div
            v-if="vars.horizontalBool && vars.buyOptionText && vars.rentOptionText"
            class="searchbox-option tw-flex tw-w-full !tw-p-[1px] lg:tw-h-[78px] lg:tw-w-[30%]"
          >
            <button
              v-if="vars.buyOptionText"
              class="select-button select-button-sales tw-uppercase"
              :class="{ active: searchType === PFilterSearchType.SALES }"
              @click="onSearchTypeClicked(PFilterSearchType.SALES)"
            >
              {{ vars.buyOptionText }}
            </button>
            <button
              v-if="vars.rentOptionText"
              class="select-button select-button-rent tw-uppercase"
              :class="{ active: searchType === PFilterSearchType.LETTINGS }"
              @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
            >
              {{ vars.rentOptionText }}
            </button>
          </div>
          <!-- input-row masaüstünde row, mobilde column olacak -->
          <div class="input-row tw-flex-col tw-flex-nowrap lg:tw-w-full lg:!tw-flex-row">
            <locations
              v-model="searchInput"
              v-model:locations="locations"
              :is-mile-selection-visible="false"
              :is-search-icon-hidden="true"
              version="v2"
              :horizontal-layout="vars.horizontalBool"
              :placeholder="variables.searchBoxPlaceholderText"
            />
            <button
              @click="onSearched()"
              class="n-secondary tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center !tw-rounded-[var(--rounded)] tw-uppercase hover:!tw-bg-[var(--c-secondary)] lg:tw-absolute lg:tw-right-0 lg:tw-top-0 lg:tw-mt-0 lg:tw-w-[30%]"
              :class="{
                'tw-flex tw-items-center tw-justify-center': vars.isSearchIconBool,
              }"
            >
              {{ vars.searchButtonText }}
              <svg
                width="20"
                class="tw-ml-3"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5014 15.8328L13.2064 11.5378C14.0004 10.331 14.3185 8.87259 14.0989 7.44483C13.8794 6.01706 13.1379 4.72154 12.018 3.80908C10.8981 2.89663 9.47948 2.43216 8.0368 2.50559C6.59412 2.57903 5.23 3.18515 4.20855 4.2066C3.1871 5.22805 2.58098 6.59216 2.50755 8.03484C2.43411 9.47752 2.89859 10.8961 3.81104 12.016C4.72349 13.1359 6.01901 13.8774 7.44678 14.097C8.87454 14.3165 10.333 13.9985 11.5397 13.2045L15.8347 17.4995L17.5014 15.8328ZM4.16807 8.33279C4.16807 6.03529 6.03724 4.16612 8.33474 4.16612C10.6322 4.16612 12.5014 6.03529 12.5014 8.33279C12.5014 10.6303 10.6322 12.4995 8.33474 12.4995C6.03724 12.4995 4.16807 10.6303 4.16807 8.33279Z"
                  fill="white"
                  fill-opacity="0.7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-else-if="
      excludedThemes.includes(theme) && variant === variants.v2 && company.company_key === 'propertyconnections'
    "
    class="on-the-fly-search-box-section tw-py-16 lg:tw-py-24"
    :class="{ 'new-homes': $route.path === '/new-homes' }"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="on-the-fly-search-box tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-6">
      <div class="text-container lg:tw-mb-8">
        <p v-if="vars.subTitleText" class="lg:tw-text-center">{{ vars.subTitleText }}</p>
        <h3 v-if="vars.titleText">{{ vars.titleText }}</h3>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" />
      </div>
      <div
        v-if="!vars.horizontalBool && (vars.buyOptionText || vars.rentOptionText)"
        class="search-button-container tw-flex tw-gap-1 max-lg:tw-w-full max-lg:tw-rounded-xl max-lg:tw-border-2 max-lg:tw-border-[#ccc] max-lg:tw-p-[1px] lg:tw-gap-4"
      >
        <button
          v-if="vars.buyOptionText"
          class="select-button"
          :class="{ active: searchType === PFilterSearchType.SALES }"
          @click="onSearchTypeClicked(PFilterSearchType.SALES)"
        >
          {{ vars.buyOptionText }}
        </button>

        <button
          v-if="vars.rentOptionText"
          class="select-button max-lg:tw-border-none"
          :class="{ active: searchType === PFilterSearchType.LETTINGS }"
          @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
        >
          {{ vars.rentOptionText }}
        </button>
      </div>
      <div
        class="property-searchbox-container on-the-fly tw-relative tw-flex tw-w-full tw-gap-4 max-lg:tw-flex-col max-lg:tw-gap-7"
        :style="`border-radius: var(--rounded);`"
      >
        <div
          v-if="vars.horizontalBool && vars.buyOptionText && vars.rentOptionText"
          class="searchbox-option tw-flex tw-w-full tw-border max-lg:tw-w-full max-lg:tw-p-[1px] max-md:tw-border lg:tw-max-w-[224px] lg:tw-p-[2px]"
          style="border-radius: var(--rounded); border-color: var(--c-border)"
        >
          <button
            v-if="vars.buyOptionText"
            class="select-button select-button-sales"
            :class="{ active: searchType === PFilterSearchType.SALES }"
            @click="onSearchTypeClicked(PFilterSearchType.SALES)"
          >
            {{ vars.buyOptionText }}
          </button>

          <button
            v-if="vars.rentOptionText"
            class="select-button select-button-rent"
            :class="{ active: searchType === PFilterSearchType.LETTINGS }"
            @click="onSearchTypeClicked(PFilterSearchType.LETTINGS)"
          >
            {{ vars.rentOptionText }}
          </button>
        </div>
        <div class="input-row">
          <locations
            v-model="searchInput"
            v-model:locations="locations"
            :is-mile-selection-visible="false"
            :is-search-icon-hidden="true"
            version="v2"
            :horizontal-layout="vars.horizontalBool"
            :placeholder="variables.searchBoxPlaceholderText"
          />
          <button
            @click="onSearched()"
            class="search-box-btn n-primary tw-h-full lg:tw-absolute lg:tw-right-0 lg:tw-top-0"
            :class="{
              'tw-flex tw-items-center tw-justify-center tw-gap-1': vars.isSearchIconBool,
            }"
          >
            <svg
              v-if="vars.isSearchIconBool"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              class="tw-flex-shrink-0"
            >
              <path
                d="M17.4995 15.8333L13.2045 11.5383C13.9985 10.3316 14.3165 8.87314 14.097 7.44537C13.8774 6.01761 13.1359 4.72208 12.016 3.80963C10.8961 2.89718 9.47752 2.43271 8.03484 2.50614C6.59216 2.57958 5.22805 3.1857 4.2066 4.20715C3.18515 5.22859 2.57903 6.59271 2.50559 8.03539C2.43216 9.47807 2.89663 10.8967 3.80908 12.0166C4.72154 13.1365 6.01706 13.878 7.44483 14.0975C8.87259 14.317 10.331 13.999 11.5378 13.205L15.8328 17.5L17.4995 15.8333ZM4.16612 8.33333C4.16612 6.03584 6.03529 4.16667 8.33279 4.16667C10.6303 4.16667 12.4995 6.03584 12.4995 8.33333C12.4995 10.6308 10.6303 12.5 8.33279 12.5C6.03529 12.5 4.16612 10.6308 4.16612 8.33333Z"
              />
            </svg>
            {{ vars.searchButtonText }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import NcButton from '~/components/common/inputs/NcButton.vue';
import Locations from '~/components/common/Locations.vue';
import { useWebsiteStore } from '~/units/website/store';
import { onTheFlySearchBox } from '~/units/properties/mixins/onTheFlySearchBox.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
import Theme3 from '~/views/theme3.vue';

export default defineNuxtComponent({
  name: 'LibraryOnTheFlyPropertySearchBox',
  components: { Locations, NcButton, BlockSymbol },

  mixins: [ComponentMixin, onTheFlySearchBox],

  data() {
    return {
      excludedThemes: ['theme2', 'theme3'],
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  mounted() {
    if (this.vars.searchTypeText) {
      this.searchType = this.vars.searchTypeText;
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['theme']),

    buttonColorsStyle() {
      let text = '';

      if (this.vars.searchButtonCustomBgColor) {
        text += `--nc-primary-button-bg-color: var(--${this.vars.searchButtonCustomBgColor});`;
      }

      if (this.vars.searchButtonCustomTextColor) {
        text += `--nc-primary-button-text-color: var(--${this.vars.searchButtonCustomTextColor});`;
      }

      if (this.theme === 'theme3') {
        text += `--nc-primary-button-radius: 0;`;
      }

      return text;
    },

    buttonTextColor() {
      if (this.vars.buttonTextColor) {
        return this.vars.buttonTextColor;
      }

      return 'var(--white)';
    },

    backgroundColor() {
      if (this.theme === 'theme2') {
        return 'background-color: var(--seashell);';
      } else if (this.theme === 'theme3') {
        return `background-color: var(--${this.vars.backgroundColor})`;
      }
      return '';
    },

    selectedBoxColorStyle() {
      if (this.theme === 'theme2') {
        return 'background-color: var(--brown); color: var(--white);';
      } else if (this.theme === 'theme3') {
        return `background-color: var(--search); color: ${this.buttonTextColor};`;
      }
      return '';
    },

    overlayTitle() {
      return getVariable(this.component, 'overlay_title-html');
    },

    variables() {
      return {
        buyOptionText: getVariable(this.component, 'buy_option-text'),
        rentOptionText: getVariable(this.component, 'rent_option-text'),
        searchBoxPlaceholderText: getVariable(this.component, 'searchbox_placeholder-text'),
        searchButtonText: getVariable(this.component, 'search_button-text'),
        boxTitleText: getVariable(this.component, 'box_title-text'),
      };
    },
  },
});
</script>

<style scoped>
#wrapper {
  position: relative;
}

.nc-secondary-button .nc-secondary-button__text {
  color: var(--nc-primary-button-text-color) !important;
}

.nc-secondary-button .nc-secondary-button__icon {
  fill: var(--nc-primary-button-text-color) !important;
}

.nc-secondary-button:hover .nc-secondary-button__icon {
  fill: var(--nc-secondary-button-hover-color) !important;
}

.nc-secondary-button:hover .nc-secondary-button__text {
  color: var(--nc-secondary-button-hover-color) !important;
}

::v-deep(.live-search-container) {
  width: 100%;
}

@media screen and (max-width: 1024px) {
  .searchbox-option {
    border-radius: var(--rounded);
  }
}

::v-deep(.properties-search-locations) {
  border-radius: var(--rounded);
}
</style>
